import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '@app/store/auth.store';

/**
 * AuthGuard для разделов приложения.
 *
 * Три состояния:
 *   - нет сессии            → /app/auth
 *   - сессия есть, NEW      → /app/registration (визард не пройден)
 *   - FULL_ACCESS           → пускаем
 *
 * Сохраняет целевой location для редиректа после успешного входа.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const needsRegistration = useAuthStore((s) => s.needsRegistration);

  if (needsRegistration) {
    return <Navigate to="/app/registration" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/app/auth" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

/**
 * Guard самого визарда: пускает только незавершённую регистрацию.
 * Без сессии уводит на вход, у завершивших — в ленту.
 */
export function RegistrationRoute({ children }: { children: React.ReactNode }) {
  const needsRegistration = useAuthStore((s) => s.needsRegistration);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (needsRegistration) return <>{children}</>;
  if (isAuthenticated) return <Navigate to="/app/feed" replace />;
  return <Navigate to="/app/auth" replace />;
}
